// Start JS Code
// Start sportDropdown js code
const sportDropdown = document.querySelector('#sport');
const otherSportPanel = document.querySelector('#otherSportPanel');

sportDropdown.addEventListener('change', () => {
     if (sportDropdown && sportDropdown.value === 'Other') {
         otherSportPanel.style.display = 'block';
     } else {
        otherSportPanel.style.display = 'none';
        otherSportPanel.querySelector('input').value = "";
     }
})
// End sportDropdown js code

// Start JWS Dropdown code
class JWSDropdown {
  constructor(dropdown) {
    this.dropdown = dropdown;
    this.trigger = dropdown.querySelector(".jws-dropdown_trigger");
    this.menu = dropdown.querySelector(".jws-dropdown_menu");
    this.options = dropdown.querySelectorAll(".jws-dropdown_option");

    this.valueInput = dropdown.querySelector(".jws-selected-value");
    this.textInput = dropdown.querySelector(".jws-selected-text");
    this.displayText = dropdown.querySelector(
      ".jws-dropdown_selected .jws-dropdown_text",
    );
    this.displayIcon = dropdown.querySelector(
      ".jws-dropdown_selected .jws-dropdown_icon",
    );

    this.init();
  }

  init() {
    // Toggle menu
    this.trigger.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });

    // Option click
    this.options.forEach((option) => {
      option.addEventListener("click", () => this.select(option));
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (!this.dropdown.contains(e.target)) {
        this.close();
      }
    });
  }

  toggle() {
    const isOpen = this.dropdown.classList.contains("open");
    this.closeAll();
    if (!isOpen) {
      this.open();
    }
  }

  open() {
    this.dropdown.classList.add("open");
    this.trigger.setAttribute("aria-expanded", "true");
  }

  close() {
    this.dropdown.classList.remove("open");
    this.trigger.setAttribute("aria-expanded", "false");
  }

  closeAll() {
    document.querySelectorAll(".jws-dropdown.open").forEach((dd) => {
      dd.classList.remove("open");
      dd.querySelector(".jws-dropdown_trigger").setAttribute(
        "aria-expanded",
        "false",
      );
    });
  }

  select(option) {
    const value = option.dataset.itemValue;
    const text = option.querySelector(".jws-dropdown_text").textContent;
    const icon = option.querySelector(".jws-dropdown_icon");

    // Update hidden inputs
    this.valueInput.value = value;
    this.textInput.value = text;

    // Update trigger UI
    this.displayText.textContent = text;
    if (icon) {
      this.displayIcon.style.backgroundColor =
        window.getComputedStyle(icon).backgroundColor;
    }

    // Update selected class
    this.options.forEach((opt) => opt.classList.remove("selected"));
    option.classList.add("selected");

    this.close();
  }
}

// Initialize all dropdowns
document.querySelectorAll(".jws-dropdown").forEach((dropdown) => {
  new JWSDropdown(dropdown);
});
// End JWS Dropdown code

// Start JWS File-Upload code
class JWSFileUpload {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.input = wrapper.querySelector('input[type="file"]');
    this.preview = wrapper.querySelector(".jws-file-upload_preview");
    this.emptyIcon = wrapper.querySelector(".jws-file-upload_empty-icon");
    this.removeBtn = wrapper.querySelector(".jws-file-upload_remove");

    this.currentImage = null;

    this.init();
  }

  init() {
    this.input.addEventListener("change", () => this.handleFile());
    this.removeBtn.addEventListener("click", () => this.removeFile());
  }

  handleFile() {
    const file = this.input.files[0];
    if (!file) return;

    if (!this.isValidImage(file)) {
      alert("Invalid image type");
      this.input.value = "";
      return;
    }

    const imageURL = URL.createObjectURL(file);

    // Remove old image if exists
    if (this.currentImage) {
      this.currentImage.remove();
    }

    // Create image
    const img = document.createElement("img");
    img.src = imageURL;
    img.alt = file.name;
    img.className = "jws-file-upload_image";

    this.preview.appendChild(img);
    this.currentImage = img;

    // Hide empty icon
    this.emptyIcon.style.display = "none";

    // Update tooltip
    this.preview.title = `${file.name} (${this.formatFileSize(file.size)})`;

    // Show remove button
    this.removeBtn.style.display = "flex";
  }

  removeFile() {
    // Clear input
    this.input.value = "";

    // Remove preview image
    if (this.currentImage) {
      this.currentImage.remove();
      this.currentImage = null;
    }

    // Show empty icon again
    this.emptyIcon.style.display = "";

    // Reset tooltip
    this.preview.title = "Upload Image";

    // Hide remove button
    this.removeBtn.style.display = "none";
  }

  isValidImage(file) {
    return file.type.startsWith("image/");
  }

  formatFileSize(size) {
    if (size < 1024) return `${size} bytes`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  }
}

// Initialize all uploads on page
document.querySelectorAll(".jws-file-upload").forEach((upload) => {
  new JWSFileUpload(upload);
});
// End JWS File-Upload code

// Start Toggle Panel code
document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll("[data-toggle-panel]");

  toggles.forEach((toggle) => {
    const panelId = toggle.dataset.togglePanel;
    const panel = document.getElementById(panelId);

    if (!panel) return;

    // Initial state sync (important if form is pre-filled)
    panel.hidden = !toggle.checked;

    toggle.addEventListener("change", function () {
      if (this.checked) {
        panel.hidden = false;
      } else {
        panel.hidden = true;

        // Reset nested inputs
        const inputs = panel.querySelectorAll("input");
        const dropdowns = panel.querySelectorAll("select");

        inputs.forEach((input) => {
          if (input.type === "checkbox" || input.type === "radio") {
            input.checked = false;
          } else {
            input.value = "";
          }
        });

        dropdowns.forEach((dropdown) => {
          dropdown.value = "";
        });
      }
    });
  });
});
// End Toggle Panel code

// Start Showing Messages code
class FormMessages {
  constructor(container) {
    this.container = document.querySelector(container);

    this.icons = {
      success: `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 650 650" fill="none">
           <path d="M491.667 225L258.333 458.333L158.331 358.333M625 325C625 490.687 490.687 625 325 625C159.315 625 25 490.687 25 325C25 159.315 159.315 25 325 25C490.687 25 625 159.315 625 325Z" stroke="currentColor" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"/>
       </svg>
      `,
      error: `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 650 650" fill="none">
           <path d="M325 491.333V491.667M325 158.333V391.667M625 325C625 490.687 490.687 625 325 625C159.315 625 25 490.687 25 325C25 159.315 159.315 25 325 25C490.687 25 625 159.315 625 325Z" stroke="currentColor" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
      info: `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 650 650" fill="none">
           <path d="M325 158.667V158.334M325 491.667V258.333M625 325C625 490.687 490.687 625 325 625C159.315 625 25 490.687 25 325C25 159.315 159.315 25 325 25C490.687 25 625 159.315 625 325Z" stroke="currentColor" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `,
    };
  }

  clear() {
    this.container.innerHTML = "";
  }

  scrollToContainer() {
    this.container.parentElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  show(type, message) {
    const msg = document.createElement("div");
    msg.className = `form-message form-message-${type}`;

    msg.innerHTML = `
      <span class="form-message-icon">
        ${this.icons[type] || ""}
      </span>
      <span class="form-message-text">
        ${message}
      </span>
    `;

    this.container.appendChild(msg);

    this.scrollToContainer();

    setTimeout(() => {
      msg.remove();
    }, 8000);
  }

  showMultiple(type, messages) {
    this.clear();

    messages.forEach((m) => {
      this.show(type, m);
    });
  }
}
// End Showing Messages code

// Start Loader code
class Loader {
  constructor(selector) {
    this.loader = document.querySelector(selector);
  }

  show() {
    this.loader.style.display = "flex";
  }

  hide() {
    this.loader.style.display = "none";
  }
}
// End Loader code

// Team/Club form submit js
document.addEventListener("DOMContentLoaded", function () {
  const teamForm = document.querySelector(".team-form");
  const messages = new FormMessages(".jws-form_messages");
  const loaderWrapper = new Loader(".jws-loader-wrapper");
  loaderWrapper.hide();

  teamForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    loaderWrapper.show();
    messages.clear();

    const teamFormData = new FormData(teamForm);
    const API_URL = "https://jws-custom-form-app.vercel.app/api/team-signup";

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        body: teamFormData,
      });

      // Parse the response
      const data = await response.json();

      // show Messages
      if (!response.ok) {
        if (data["errors"]) {
          const errors = data["errors"].map((e) => e.msg);
          loaderWrapper.hide();
          messages.showMultiple("error", errors);
        } else {
          loaderWrapper.hide();
          messages.show("error", data["error"]);
        }
        return;
      }

      loaderWrapper.hide();
      messages.show("success", data["success"]);
      teamForm.reset();
    } catch (err) {
      loaderWrapper.hide();
      messages.show("error", "Network error. Please try again.");
    }
  });
});
// End Team/Club form submit js